import Button from '@/components/shared/Button/Button';
import Popup from '@/components/shared/Popup/Popup';
import { POPUPS } from '@/js/AppState';
import PopupsManager from 'react-sdk/PopupsManager';
import classes from './PopupImgFullScreen.module.css';

const PopupImgFullScreen = () => {
  const data = PopupsManager.getData(POPUPS.IMG_FS);
  const { imgUrl, onValid } = data;

  return (
    <Popup className={classes.PopupImgFullScreen}>
      <div
        className={classes.PopupContent}
        style={{ backgroundImage: `url(${imgUrl})` }}
      >
        <div className={classes.btn_ctnr}>
          <Button onClick={() => { PopupsManager.close(POPUPS.IMG_FS); onValid?.(); }}>
            Continuer
          </Button>
        </div>
      </div>
    </Popup>
  );
};

export default PopupImgFullScreen;
